const BatchSendUnit = {
  tableConfig: {
    // showCheckbox: true
  },
  queryList: [
    {
      name: 'department',
      label: '所属学院',
      component: 'input'
    },
    {
      name: 'contactName',
      label: '联系人',
      component: 'input'
    },
    {
      name: 'contactTel',
      label: '联系电话',
      component: 'input'
    },
    {
      name: 'identityCard',
      label: '证件号码',
      component: 'input'
    }
  ],
  urlMap: {
    select: '/school/schoolDegreeOffice/list',
    batchSendReview: '/school/schoolDegreeOffice/relateAcademy'
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'department',
      label: '所属学院'
    },
    {
      name: 'contactName',
      label: '联系人'
    },
    {
      name: 'contactTel',
      label: '联系电话'
    },
    {
      name: 'idCardType',
      label: '证件类型'
    },
    {
      name: 'identityCard',
      label: '证件号码'
    },
    {
      name: 'unitName',
      label: '单位名称'
    },
    {
      name: 'parentName',
      label: '上级联系人'
    },
    {
      name: 'operation',
      label: '操作',
      width: 80,
      actionList: [
        {
          label: '指派',
          name: 'batchSend',
          kind: 'primary', // error
          type: 'request',
          method: 'post',
          data: {
            id: '{parentId}',
            secondZpdwId: '{id}'
          },
          addr: 'batchSendReview'
        }
      ]
    }
  ]
}
export default BatchSendUnit



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/sendUnit.js